import { NzSafeAny } from 'ng-zorro-antd/core/types';

export interface OhayoChartConfig {
  theme?: string | { [key: string]: NzSafeAny };
}
